import React from 'react';
import Us1_pre_sub from './us1_pre_sub';

const Us1_pre = () => {
  return (
    <div>
     <Us1_pre_sub /> 
    </div>
  );
}

export default Us1_pre;
